import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "departure" }
const _hoisted_2 = { class: "departure__t" }
const _hoisted_3 = { class: "departure__t-l" }
const _hoisted_4 = { class: "departure__t-l-cc" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "departure__t-l-d",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#svg-button-arrow" })
], -1 /* HOISTED */)
const _hoisted_6 = { class: "departure__t-l-cc" }
const _hoisted_7 = { class: "departure__t-l-dt" }
const _hoisted_8 = {
  key: 1,
  class: "departure__t-l-tbc"
}
const _hoisted_9 = { class: "departure__t-r" }
const _hoisted_10 = { class: "departure__b" }
const _hoisted_11 = { class: "departure__b-l" }

import { PropType, computed, inject } from 'vue'
import { AppSettingsKey } from './../../types/keys'
import type { Departure, TranslatedField, AppSettings, CurrentCulture } from '../../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DepartureRow',
  props: {
  journeyTimeText: {
    type: Object as PropType<TranslatedField>,
    required: true
  },
  journeyTimeTextSuffix: {
    type: Object as PropType<TranslatedField>,
    required: true
  },
  departure: {
    type: Object as PropType<Departure>,
    required: true,
  },
  currentCulture: {
    type: Object as PropType<CurrentCulture>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { resourceStrings } = inject(
  AppSettingsKey
) as AppSettings

const statusClass = computed<string>(() => {
  switch (props.departure.statusColour) {
    case 'red':
      return 'departure__b-r--warning'
    case 'green':
      return 'departure__b-r--success'
    default:
    case 'default':
      return 'departure__b-r--info'
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(__props.departure.departureTimeDisplayText) + " ", 1 /* TEXT */),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.departure.departureTimeZoneDisplayText), 1 /* TEXT */),
        (__props.departure.arrivalTimeDisplayText && __props.departure.arrivalTimeDisplayText.trim() !== '')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(__props.departure.arrivalTimeDisplayText) + " ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.departure.arrivalTimeZoneDisplayText), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("strong", null, _toDisplayString(__props.journeyTimeText[__props.currentCulture.cultureShortCode]), 1 /* TEXT */),
                _createTextVNode(" " + _toDisplayString(__props.journeyTimeTextSuffix[__props.currentCulture.cultureShortCode]), 1 /* TEXT */)
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(resourceStrings)['TravelUpdates.Labels.DepartureTime']) + " " + _toDisplayString(_unref(resourceStrings)['TravelUpdates.Labels.ToBeConfirmed']), 1 /* TEXT */))
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(resourceStrings)['TravelUpdates.Labels.Status']), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(__props.departure.letter), 1 /* TEXT */),
      _createElementVNode("div", {
        class: _normalizeClass(['departure__b-r', statusClass.value])
      }, _toDisplayString(__props.departure.status[__props.currentCulture.cultureShortCode]), 3 /* TEXT, CLASS */)
    ])
  ]))
}
}

})